// extracted by mini-css-extract-plugin
module.exports = {"MainWrap":"PageLoader_MainWrap__1szfZ","Spinner":"PageLoader_Spinner__3LTPx"};